<ng-container *ngIf="dateRangeFilterModel$ | async as dateRangeFilterModel">
  <div class="ness-filter-tag p-2 me-2 mb-2">{{ dateRangeFilterModel.startDate | date:'shortDate' }} - {{ dateRangeFilterModel.endDate | date:'shortDate' }}</div>
</ng-container>
